import {EventsRepository} from './EventsRepository';
import {BehaviorSubject} from 'rxjs';
import {PartEvent} from '../../models/PartEvent';
import {EventInteractor} from '../../ui/events/EventList/EventListPresenter';

export class DefaultEventInteractor implements EventsRepository, EventInteractor {
    public events = new BehaviorSubject<PartEvent[]>(this.initialEvents);

    constructor(private initialEvents: PartEvent[]) {}

    public add(event: PartEvent) {
        this.events.next([...this.events.value, event]);
    }

    public delete(toBeDeletedEvent: PartEvent): void {
        this.events.next([...this.events.value.filter((event) => event.__uuid !== toBeDeletedEvent.__uuid)]);
    }
}
